import instance from "services/axiosServices";

/**
 * @function postExportarSolicitacao
 * @param {Object} params - parâmetros.
 * @param {string} params.idEmpreendimento - GUID do empreendimento.
 * @param {Date | null} params.dataInicioPeriodoCriacao - data de início.
 * @param {Date | null} params.dataFimPeriodoCriacao - data de fim.
 * @returns {Promise<any>} - retorna confirmação da request.
 */
export const postExportarSolicitacao = async (params: {
  idEmpreendimento: string;
  dataInicioPeriodoCriacao: Date | null;
  dataFimPeriodoCriacao: Date | null;
}) => {
  const url = "locais/admin/solicitacaoVisita/exportar-solicitacao/v1";
  const response = await instance.post(url, params);
  return response?.data;
};
